import { useState } from "react";
import axios from 'axios';
import { devURL } from "../constants/constants";

export default function Performance() {
    const [ response, setResponse ] = useState(null);

    async function checkPerformance() {
        try {
            await axios({
                method: 'get',
                url: `${devURL}/check-performance`
            }).then(response => setResponse(response.data))
        } catch(error) {
            console.log(error)
        }
    };

    // response && console.log(response)

    return (
        <div className="performance">
            <div className="check-button">
                <h1>Sprawdź działanie aplikacji</h1>
                <h6>Nieaktywne.</h6>
                {/* <button onClick={checkPerformance}>sprawdź</button> */}
            </div>
        </div>
    )
};